import { useForm } from "@inertiajs/react";
import Button from "@/components/ui/Button";
import { Field, Input } from "@/components/ui/Field";

export default function AdjustmentForm({ user_id }: { user_id: number }) {
  const { data, setData, post, processing, reset } = useForm({
    amount: 0,
    reason: "",
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    post(`/users/${user_id}/adjustments`);
    reset();
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="border-line/20 flex flex-col gap-4 border-t-2 pt-4"
    >
      <p className="font-display text-subheading text-ink font-bold">
        New adjustment
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Amount">
          <Input
            type="number"
            value={data.amount}
            onChange={(e) => setData("amount", Number(e.target.value))}
          />
        </Field>

        <Field label="Reason" hint="Visible to the user.">
          <Input
            value={data.reason}
            onChange={(e) => setData("reason", e.target.value)}
          />
        </Field>
      </div>

      <Button type="submit" className="w-fit" disabled={processing}>
        {processing ? "Adding…" : "Add"}
      </Button>
    </form>
  );
}
